import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/use-toast';
import { useApp } from '@/context/AppContext';
import { serviceDeleteTypeNiche } from '@/services/utils';
import { useState } from 'react';

export function DeleteNiche({ id }: { id: number }) {
  const [isOpen, setIsOpen] = useState(false);
  const { callApis } = useApp();

  const deleteNiche = async () => {
    try {
      await serviceDeleteTypeNiche({ id });
      await callApis();

      toast({
        title: 'Nicho excluído com sucesso!',
        variant: 'default',
      });

      setIsOpen(false);
    } catch (error) {
      toast({
        title: 'Erro ao excluir o nicho.',
        description: error?.message || 'Ocorreu um erro ao excluir o nicho. Tente novamente.',
        variant: 'destructive',
      });
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogTrigger asChild>
        <Button
          onClick={() => setIsOpen(true)}
          variant="destructive"
          className="text-white h-6 w-2 rounded-r rounded-l-none bg-red-600"
        >
          x
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Deseja Excluir Planilha?</AlertDialogTitle>
          <AlertDialogDescription>
            Após excluir, não será possível recuperar os dados da planilha.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => setIsOpen(false)}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={() => deleteNiche()}>Excluir</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
